import React from 'react';
import { Box, Paper } from '@mui/material';
import { DefaultLayout } from '../../components/layout/default-layout';
import { useMetaTitle } from '../../hooks';
import { useFeatureToggles } from '../../feature-toggles';
import { PageNotFound } from '../../404';
import { WithUserScopedServiceProviderUnitCheck } from '../service-provider-unit-calendar/with-user-scoped-service-provider-unit-check';
import { useUdfoererAreaAccess } from '../citizen/serviceprovider/hooks/use-service-provider-area-access';
import { ServiceProviderUnitOverview } from './service-provider-unit-overview';

function ServiceProviderUnitOverviewContent() {
  useMetaTitle('Enhedsoverblik');

  return (
    <Box sx={{ px: 2, pt: 2 }}>
      <Paper elevation={0} sx={{ bgcolor: 'common.white', p: 2, borderRadius: 1 }}>
        <ServiceProviderUnitOverview />
      </Paper>
    </Box>
  );
}

export function ServiceProviderUnitOverviewPage() {
  const { isFeatureEnabled } = useFeatureToggles();
  const hasUdfoererAreaAccess = useUdfoererAreaAccess();

  if (!isFeatureEnabled('ShowAiServiceProviderDemo') || !hasUdfoererAreaAccess) {
    return <PageNotFound />;
  }

  return (
    <DefaultLayout>
      <WithUserScopedServiceProviderUnitCheck>
        <ServiceProviderUnitOverviewContent />
      </WithUserScopedServiceProviderUnitCheck>
    </DefaultLayout>
  );
}
